/** Table row item when previewing lob mail recipients before sending */
/** Table row item when previewing lob mail recipients before sending */
export class LobMailPreviewRecipient
{
    unitIds: number[] = [];
    ownerId: number;
    unitTitles: string;
    name: string;
    invoicePdfPageCount: number;
    displayAddress = '';
    isDuplicate = false;
    isRemoved = false;
    isIncluded = false;

    constructor(recipient: any) {
        this.unitIds = recipient.unitIds;
        this.ownerId = recipient.ownerId;
        this.unitTitles = recipient.unitTitles;
        this.name = recipient.name;
        this.invoicePdfPageCount = recipient.invoicePdfPageCount;
        this.isDuplicate = recipient.isDuplicate;
        this.isRemoved = recipient.isRemoved;
        this.isIncluded = recipient.isIncluded;
        this.displayAddress = recipient.address;
    }
}
